import {
  AttachmentFileInterface,
  UnsavedAttachmentFileInterface,
} from 'shared/components/dashboard-mail-editor/types/email-interface'

export function getFilteredAttachmentsList(
  state: (AttachmentFileInterface | UnsavedAttachmentFileInterface)[],
  file: { id: number; name: string; path: string; filename: string },
) {
  return state.filter(attachment => {
    if ('id' in attachment) {
      return attachment.id !== file.id
    }
    return attachment.file.id !== file.id
  })
}
